import NoResults from './NoResultsRow';
import ArticleZeroState from './ArticleZeroState';
import { jsx as _jsx } from "react/jsx-runtime";
const ArticleTableEmptyState = ({
  emptyStateType
}) => {
  return emptyStateType === 'FIRST_TIME_IN_APP' ? /*#__PURE__*/_jsx(ArticleZeroState, {}) : /*#__PURE__*/_jsx(NoResults, {});
};
export default ArticleTableEmptyState;